import axios from 'axios';

// Sunucunun varsayılan yolunu tutan Axios Kopyası
const api = axios.create({
    baseURL: process.env.NODE_ENV === 'production'
        ? '/api'
        : (process.env.REACT_APP_API_URL || 'http://localhost:5000/api'),
    withCredentials: true,
});

api.interceptors.request.use(
    (config) => {
        const storedToken = sessionStorage.getItem('auth_token') || localStorage.getItem('auth_token');

        if (storedToken) {
            config.headers.Authorization = `Bearer ${storedToken}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Token süresi dolunca otomatik logout yapan Response Interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 || error.response?.data?.expired) {
            localStorage.removeItem('user');
            localStorage.removeItem('auth_token');
            sessionStorage.removeItem('auth_token');

            // Zaten login sayfasında değilsek yönlendir
            if (window.location.pathname !== '/login') {
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);

export default api;
